export default {
  app: {
    brand: 'Zhengjia Digital'
  },
  nav: {
    home: 'Home',
    games: 'Games',
    orders: 'My orders',
    coupons: 'Coupons',
    recharge: 'Top up',
    recruit: 'Recruit',
    partner: 'Partners',
    faq: 'FAQ'
  },
  common: {
    langZh: '简体中文',
    langEn: 'English',
    login: 'Log in',
    register: 'Sign up',
    registerLogin: 'Sign up / Log in',
    balance: 'Wallet balance',
    guest: 'Guest',
    logout: 'Log out'
  },
  announcement: {
    title: 'Notice',
    ok: 'Got it'
  },
  home: {
    sectionTitleText: 'Most Popular, Best Selling, New Releases',
    slogan: 'All games support every platform — boost streamers\' live income at scale',
    sectionHot: 'Most Popular',
    sectionBest: 'Best Selling',
    sectionNew: 'New Releases',
    cardBadge: 'All Platforms',
    viewAll: 'View all',
    noGames: 'No games yet',
    title: 'Digital access,\ndelivered instantly.',
    subtitle: 'Reliable digital goods and automated access for creators and players across leading content platforms.',
    joinNow: 'How it works',
    viewGames: 'Explore all products',
    metricPlatforms: 'major content platforms',
    metricDelivery: 'automated delivery and access',
    metricTrackValue: 'Trackable',
    metricTrack: 'transparent order status',
    feature1Title: 'Auto delivery',
    feature1Desc: 'Processed after payment',
    feature2Title: 'Multi-platform',
    feature2Desc: 'Leading platforms supported',
    feature3Title: 'Order tracking',
    feature3Desc: 'Clear status at every step',
    feature4Title: 'After-sales care',
    feature4Desc: 'Binding and issue support',
    sectionTitle: 'Designed for reliable delivery',
    sectionDesc: 'Every step stays clear and focused, from purchase and access to after-sales support.',
    card1Title: 'Automated digital delivery',
    card1Desc: 'Cards or access are processed automatically after purchase, reducing wait time.',
    card2Title: 'After-sales & guarantee',
    card2Desc: 'Clear rules, quick response, worry-free cooperation.',
    card3Title: 'Guild partnership details',
    card3Desc: 'Transparent settlement, efficient coordination, long-term win-win.'
  },
  pages: {
    gamesTitle: 'Games',
    gamesDesc: 'Put game categories, cards, filters/search here.',
    recruitTitle: 'Recruit',
    recruitDesc: 'Put requirements, cooperation mode, revenue info here.',
    partnerTitle: 'Partners',
    partnerDesc: 'Studio, operations, and agency partnership details.',
    faqTitle: 'FAQ',
    faqDesc: 'Put frequently asked questions and answers here.'
  },
  recruit: {
    introTitle: 'Zhengjia Live Guild',
    introSubtitle: 'Stable income with transparent, flexible settlement anytime.',
    introBody: 'Zhengjia Media focuses on game and entertainment live streaming, combining talent incubation, content innovation, and brand growth. Based in Linyi, Shandong, we operate across more than 20 provinces. Guided by making streaming easier and more fun, we have built mature recruitment, training, and monetization systems on platforms like Douyin. Our in-house game team keeps launching hit prank-game content, while dedicated ops teams work alongside streamers to grow revenue steadily.',
    typesTitle: 'Streamer Types We Recruit',
    typesSubtitle: 'In-house prank games with early beta access for guild members to expand monetization.',
    prankGames: 'Prank Mini-games',
    gameMario: 'Mario Prank',
    gameOnlyClimb: 'ONLY CLIMB Prank',
    gameHalfSword: 'Half Sword Prank',
    gameGettingOverIt: 'Getting Over It Prank',
    gamePeace: 'Peacekeeper Elite',
    gameHonor: 'Honor of Kings',
    gameDelta: 'Delta Force',
    servicesTitle: 'What We Offer Signed Streamers',
    servicesSubtitle: 'Request a new operator if needed, fair exit supported — we protect your earnings.',
    service1: 'Early access to exclusive games, some modes not public',
    service2: 'Weekly updates on trending gameplay and ranking events',
    service3: 'Free live room setup and tuning with fast support',
    service4: 'Official platform traffic and exposure support',
    service5: 'Dedicated ops with co-streaming guidance and session reviews',
    service6: 'Free game plugins and scripts at no extra cost',
    service7: 'Short-video editing and asset production support',
    service8: 'Custom game effects and interactive modes for top streamers'
  },
  partner: {
    title: 'Studio, Ops & Agency Partnership',
    subtitle: 'Leverage Zhengjia Media\'s exclusive resources to recruit more streamers and grow their revenue.'
  },
  faq: {
    searchPh: 'Search questions...',
    noResult: 'No matching questions. Try another keyword.',
    notFound: 'Didn\'t find your question?',
    contact: 'Contact support',
    contactHint: 'Reach us via the Partners page or order after-sales channels. Include your order number for faster help.',
    q1: 'How do I buy a game?',
    a1: 'Open the game list, choose a title, tap Buy, fill in the authorization platform and account, then complete payment.',
    q2: 'Which payment methods are supported?',
    a2: 'WeChat Pay, Alipay, and wallet balance.',
    q3: 'How do I rebind an account?',
    a3: 'Sign in, go to My orders, find the order, and tap Rebind to enter a new authorization account.',
    q4: 'What if I forget my password?',
    a4: 'Online password recovery is not available yet. Please contact support for account help.',
    q5: 'How do I register?',
    a5: 'Tap Log in at the top right, then Go register on the login page and complete the form.',
    q6: 'When does my order take effect?',
    a6: 'Orders take effect immediately after successful payment; licenses or card keys are issued automatically.',
    q7: 'Can I get a refund?',
    a7: 'Virtual goods are generally non-refundable once sold. Contact support for special cases.'
  },
  gamesPurchase: {
    pickGame: 'Buy',
    dialogTitle: 'Purchase license',
    dialogTitleCard: 'Purchase card key',
    dialogTitleZhengjia: 'Purchase Zhengjia auth',
    platform: 'Authorization platform',
    platformPh: 'Select a platform',
    platformInvalid: 'Please select a platform.',
    platformDouyin: 'Douyin',
    platformKuaishou: 'Kuaishou',
    platformBilibili: 'Bilibili',
    platformTiktok: 'TikTok',
    platformXiaohongshu: 'Xiaohongshu',
    authorizationAccount: 'Authorization account',
    authorizationAccountPh: 'Enter one platform account to authorize',
    authorizationAccountInvalid: 'Enter one valid authorization account.',
    authorizationAccountMultiple: 'Only one authorization account is allowed.',
    senseyunPhone: 'Senseyun account',
    senseyunPhonePh: 'Enter mobile number or email',
    phoneInvalid: 'Enter a valid Senseyun mobile number or email.',
    authorizationSection: 'Authorization details',
    authorizationSectionDesc: 'Verify the platform account and Senseyun account (mobile or email)',
    authorizationSectionDescSenseyun: 'Verify the platform account and Senseyun account (mobile or email)',
    authorizationSectionDescCard: 'Choose a platform and enter the authorization account. Your card key is shown after payment.',
    authorizationSectionDescZhengjia: 'Choose a platform and enter the authorization account. Zhengjia auth cards are issued after payment.',
    planSectionDesc: 'Choose the license duration',
    paymentSection: 'Payment',
    paymentSectionDesc: 'Select a payment channel',
    methodWebFixed: 'Web payment',
    cardProduct: 'Card-key product',
    licenseProduct: 'Senseyun license',
    zhengjiaProduct: 'Zhengjia auth',
    payAmount: 'Amount due',
    descCard: 'Choose a platform and enter the authorization account. Your card key is shown after payment.',
    cardSecret: 'Your card key',
    planLabel: 'Plan',
    planMonth: 'Monthly',
    planQuarter: 'Quarterly',
    planYear: 'Yearly',
    retailRef: 'Retail {price}',
    resultPlan: 'Plan',
    needLogin: 'Please sign in first.',
    needBackend: 'Enable backend mode (VUE_APP_USE_BACKEND=true) to purchase.',
    balancePay: 'Pay with balance',
    onlinePay: 'Online payment',
    payType: 'Payment method',
    payMethod: 'Checkout method',
    methodWeb: 'Web checkout (QR / redirect, etc.)',
    methodJump: 'Redirect checkout (link only)',
    submitOnline: 'Pay',
    successBalance: 'Purchase successful',
    invalidGamePrice: 'Invalid game price. Check monthly/quarterly/yearly price configuration.',
    planUnavailable: 'This plan is not available for the current game. Please select another plan.',
    gameNotFound: 'Game not found. Check that it is published and the product license id matches the request.',
    gameOffShelf: 'This game is off shelf and cannot be purchased.',
    outOfStock: 'This game is out of stock.',
    licenseMissing:
      'This game has no Sense product license id: set games.senseyun_license_id (issueLicenseByProduct only; template id fallback is removed).',
    senseyunError: 'Sense license issue failed',
    senseyunLicenseNotFound:
      'Sense says the license/product does not exist: verify games.senseyun_license_id matches the console product license id and the same developer account as SENSEYUN_APP_ID.',
    senseyunUserNotFound:
      'Sense says the user does not exist: add that mobile user in Sense first, or use an account that already exists in Sense.',
    insufficient: 'Insufficient balance',
    debitHint: 'License may have been issued but balance debit failed. Contact support with the order id.',
    resultTitle: 'Purchase order',
    resultSub: 'After online payment, license issuance may be slightly delayed. Refresh to check.',
    polling: 'Checking order status…',
    orderNo: 'Merchant order no.',
    status: 'Status',
    senseDesc: 'Sense message',
    fulfillmentDesc: 'Fulfillment note',
    refresh: 'Refresh',
    close: 'Close',
    stPending: 'Pending',
    stPaid: 'Completed',
    stFailed: 'Failed',
    stProcessing: 'Processing',
    stLicenseFailed: 'Paid but license failed',
    stClosed: 'Closed',
    configMissing: 'Public API base is not configured on the server.',
    jumpTip: 'Redirecting to payment…'
  },
  orders: {
    title: 'My orders',
    desc: 'View purchase history. Completed orders show card secrets and delivery details here.',
    searchPh: 'Search by order no. / phone / auth account',
    refresh: 'Refresh',
    empty: 'No orders yet',
    goShop: 'Browse games',
    needLogin: 'Please log in using the button at the top right to view your orders',
    needBackend: 'Enable backend mode (VUE_APP_USE_BACKEND=true) to use order history.',
    loadFailed: 'Failed to load orders',
    colOrderNo: 'Order no.',
    colGame: 'Product',
    colPlan: 'Plan',
    colAmount: 'Amount',
    colPayChannel: 'Payment',
    colStatus: 'Status',
    colCreated: 'Created',
    colActions: 'Actions',
    viewDetail: 'Details',
    viewCard: 'View card',
    detailTitle: 'Order details',
    detailSub: 'View order status, authorization info, and card secrets.',
    payBalance: 'Balance',
    payOnline: 'Online',
    extraAuth: 'Extra auth',
    extraAuthZhenggu: 'Zhengu++',
    extraAuthOnly: 'Only++',
    copyCard: 'Copy card',
    retryFulfill: 'Retry delivery',
    retryFulfillOk: 'Card delivered successfully',
    retryFulfillFail: 'Delivery still failed. Please retry later or contact support.',
    copyOk: 'Copied',
    copyFail: 'Copy failed — please copy manually',
    rebind: 'Rebind',
    lock: 'Lock',
    lockTitle: 'Lock license / card',
    lockSub: 'After locking, the license or card secret can no longer be used. Please confirm before proceeding.',
    lockConfirmGame: 'Lock the Senseyun game license? It will no longer be usable.',
    lockConfirmZhenggu: 'Disable the Zhengu++ card? It will no longer be usable.',
    lockConfirmOnly: 'Disable the Only++ card? It will no longer be usable.',
    lockConfirmBoth: 'Lock the Senseyun license and disable the extra-auth card at the same time? They will no longer be usable.',
    lockSubmit: 'Confirm lock',
    lockCancel: 'Cancel',
    lockOk: 'Locked successfully',
    lockFailed: 'Lock failed',
    lockAgentRequired: 'Only agent users can lock licenses',
    lockNotSupported: 'This order cannot be locked',
    lockSenseyunFailed: 'Failed to lock Senseyun license',
    lockZhengguFailed: 'Failed to disable Zhengu++ card',
    unbindMachine: 'Unbind device',
    unbindMachineTitle: 'Unbind device',
    unbindMachineConfirm: 'Unbind the machine code currently tied to this Zhengu++ card? It can then be bound on a new device.',
    unbindMachineSubmit: 'Confirm unbind',
    unbindMachineCancel: 'Cancel',
    unbindMachineOk: 'Device unbound successfully',
    unbindMachineOkRemain: 'Device unbound successfully. Remaining unbind attempts: {count}',
    unbindMachineFailed: 'Failed to unbind device',
    unbindMachineAgentRequired: 'Only agent users can unbind devices',
    unbindMachineNotSupported: 'This order does not support device unbind',
    unbindMachineNotReady: 'Zhengu++ unbind API is unavailable',
    rebindTitle: 'Rebind account',
    rebindSub: 'Choose which program to rebind and enter the matching account details. Cross-platform rebind is not supported.',
    rebindCurrentAccount: 'Current account',
    rebindCurrentAuthAccount: 'Current live authorization account',
    rebindCurrentSenseyunPhone: 'Current Senseyun account',
    rebindNewAccount: 'New live authorization account',
    rebindNewAccountPh: 'Enter one new platform live authorization account',
    rebindNewSenseyunPhone: 'New Senseyun account',
    rebindNewAccountInvalid: 'Enter a valid new live authorization account',
    rebindSameAccount: 'The new account must differ from the current one',
    rebindSamePhone: 'The new account must differ from the current one',
    rebindSubmit: 'Submit rebind',
    rebindOk: 'Rebind succeeded.',
    rebindFailed: 'Rebind failed',
    rebindNotReady: 'This order type does not support rebind yet.',
    rebindNotSupported: 'This order cannot be rebound.',
    rebindUnbindExhausted: 'No free unbind attempts left; rebind is unavailable.',
    rebindUnbindTargets: 'Programs to unbind',
    rebindUnbindGame: 'Game license (Senseyun cloud lock)',
    rebindUnbindZhenggu: 'Zhengu++ extra card',
    rebindUnbindOnly: 'Only++ extra card',
    rebindUnbindRequired: 'Select a program to rebind',
    rebindSenseyunUnlockFailed: 'Failed to lock game license',
    rebindSenseyunLockFailed: 'Failed to lock game license',
    rebindFeeFree: 'This rebind is free ({remaining} free attempt(s) left).',
    rebindFeeUnlimited: 'Unlimited free rebinds for this program.',
    rebindFeeCharge: 'This rebind costs {fee}.',
    rebindFeeChargeBalance: 'This rebind will deduct {fee} from your balance.',
    rebindInsufficientBalance: 'Insufficient balance. This rebind costs {fee}. Use online pay or top up first.',
    rebindSenseyunExpired: 'Senseyun phone rebind is only allowed within 24 hours after purchase.',
    rebindSenseyunRemainLabel: 'Rebind time left',
    rebindSenseyunRemainValue: '{time} left',
    rebindSenseyunRemainExpired: 'Expired, rebind unavailable',
    rebindPayBalance: 'Balance',
    rebindPayOnline: 'Online pay',
    rebindPayChannel: 'Payment method',
    rebindOnlineTip: 'Rebind will complete automatically after payment.'
  },
  coupons: {
    title: 'My coupons',
    filterAll: 'All',
    filterUnused: 'Unused',
    filterUsed: 'Used',
    filterExpired: 'Expired',
    empty: 'No coupons yet',
    loadFailed: 'Failed to load coupons',
    unnamed: 'Coupon',
    validTo: 'Valid until',
    scopeAll: 'All games (no threshold)',
    scopeGame: 'Specific games',
    statusUnused: 'Unused',
    statusUsed: 'Used',
    statusExpired: 'Expired',
    statusLocked: 'Locked',
    select: 'Coupon',
    selectNone: 'Do not use a coupon',
    discount: 'Saved {amount}',
    payAfter: 'Amount after coupon'
  },
  rechargeGift: {
    title: 'Recharge gifts',
    tip: 'Top up ¥{amount}+ and get “{coupon}” ¥{discount} coupon ×{count}'
  },
  rechargeCashback: {
    title: 'Recharge cashback',
    tip: 'Top up ¥{amount}+ and get ¥{cashback} cashback to balance'
  },
  auth: {
    loginTitle: 'Log in',
    loginSub: 'Welcome back, please sign in',
    registerTitle: 'Sign up',
    registerSub: 'Create an account to continue',
    username: 'Username',
    usernamePh: 'Enter username',
    usernameReq: 'Please enter username',
    password: 'Password',
    passwordPh: 'Enter password',
    passwordReq: 'Please enter password',
    captcha: 'Captcha',
    captchaPh: 'Enter captcha',
    captchaReq: 'Please enter captcha',
    refreshCaptcha: 'Click to refresh captcha',
    captchaInvalid: 'Captcha is incorrect, please try again',
    loginBtn: 'Log in',
    loginOk: 'Logged in',
    loginFailed: 'Login failed',
    registerBtn: 'Sign up',
    registerOk: 'Signed up, please log in',
    registerFailed: 'Sign up failed',
    noAccount: "Don't have an account?",
    goRegister: 'Sign up',
    hasAccount: 'Already have an account?',
    goLogin: 'Log in',
    userExists: 'Username already exists',
    userNotFound: 'User not found',
    passwordInvalid: 'Incorrect password',
    accountLocked: 'Too many failed attempts, please try again later',
    rateLimited: 'Too many requests, please try again later',
    passwordTooShort: 'Password must be at least 6 characters',
    logoutOk: 'Logged out'
  },
  recharge: {
    title: 'Wallet top-up',
    amount: 'Amount',
    payType: 'Payment method',
    payMethod: 'API method',
    methodWeb: 'Web (may return QR / jump URL, etc.)',
    methodJump: 'Jump only (returns a redirect URL)',
    submit: 'Pay',
    scanTitle: 'Scan to pay',
    scanTip: 'Status updates automatically after payment; you can also tap below to check.',
    paidGoResult: 'I have paid',
    payInfo: 'Payment payload',
    needLogin: 'Please sign in first',
    configMissing:
      'Server payment URLs are not configured (PAY_PUBLIC_API_BASE / PAY_RETURN_FRONT_BASE). Contact the administrator.',
    failed: 'Could not start payment',
    resultTitle: 'Top-up status',
    resultSub: 'If you already paid, balance may update with a short delay. Refresh or go home to check.',
    polling: 'Checking order status…',
    missingOrder: 'Missing order id',
    queryFailed: 'Query failed',
    network: 'Network error',
    orderNo: 'Merchant order no.',
    status: 'Status',
    platformNo: 'Platform order no.',
    refresh: 'Refresh',
    backHome: 'Back to home',
    stPending: 'Pending',
    stPaid: 'Paid',
    stFailed: 'Failed',
    stClosed: 'Closed'
  }
}
